
import Vue from "vue";
import $ from "jquery";
import Component from "vue-class-component";
import { Mutation, State } from "vuex-class";
import FlagIcon from "@/components/icons/FlagIcon.vue";
import { WHATSAPP_LINK } from "@/constants/misc.constant";

@Component({
  components: { FlagIcon },
})
export default class AppNavbarLanding extends Vue {
  @State("locale")
  private locale!: string;

  @Mutation("mutationLocale")
  private mutationLocale: any;

  private waLink = WHATSAPP_LINK;

  private navbarToggle() {
    $("#main-nav").toggleClass("navbar-expanded");
    $("#nav-mobile").toggleClass("show");
  }
}
